import SettingsWizardDialog from '@/components/settings/wizard/SettingsWizardDialog.vue'

export default {
  components: {
    SettingsWizardDialog
  },

  mixins: [],

  data() {
    return {
      settingsWizardDialogVisible: false
    }
  },

  created() {
    this.$bus.$on('show-settings-wizard', this.onShowSettingsWizard)

    this.initAppWizard()
  },

  beforeDestroy() {
    this.$bus.$off('show-settings-wizard', this.onShowSettingsWizard)
  },

  methods: {
    initAppWizard() {
      if (this.userIsOwner || this.userIsSuperAdmin) {
        this.onShowSettingsWizard(this.posUser.ShowSettingsWizard)
        if (this.posUser.ShowSettingsWizard) {
          const tmpUser = this.posUser
          tmpUser.ShowSettingsWizard = false
          this.posUser = tmpUser
        }
      }
    },

    onShowSettingsWizard(visible = true) {
      this.settingsWizardDialogVisible = visible
    }
  }
}
